import type { ConnectionStatus } from '../net/battleConnection.ts';

/** Thin wrapper over the static HUD markup in index.html. */
export class Hud {
  private readonly connection = document.querySelector<HTMLElement>('#hud-connection');
  private readonly players = document.querySelector<HTMLElement>('#hud-players');

  setConnection(status: ConnectionStatus, detail?: string): void {
    if (!this.connection) return;
    const label =
      status === 'online' ? 'battle server: online'
      : status === 'connecting' ? 'battle server: connecting…'
      : `battle server: offline${detail ? ` — ${detail}` : ''}`;
    this.connection.textContent = label;
    this.connection.dataset['state'] = status;
  }

  setPlayers(count: number): void {
    if (!this.players) return;
    this.players.textContent = count === 1 ? '1 player' : `${count} players`;
  }
}
